var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.to},on:{"click":_vm.navigate}},[_c('v-slot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }